import { FiltersToolbarFilter } from '@hqo/filters-toolbar';
import { Badge } from '@hqo/ui-atoms';
import { useIntl } from 'react-intl';

import { useHostFilter } from './use-host-filter.hook';
import { cn } from '@hqo/react-hooks';
import { HostFilterMultiSelect } from './host-filter-multi-select';

export const HostFilter = (): JSX.Element => {
  const {
    options,
    selectedOptions,
    hostLabel,
    selectedCount,
    handleChange,
    isSet,
    searchValue,
    handleSearch,
    isLoading,
    onFetchMore,
    isFetchingMore,
    hasMore,
  } = useHostFilter();
  const { formatMessage } = useIntl();
  const selectAllLabel = formatMessage({ id: 'labels.filtersToolbar.selectAll', defaultMessage: 'Select all' });

  return (
    <FiltersToolbarFilter priority={4} order={1} id="host" isSet={isSet} className="min-w-52 max-w-70">
      <HostFilterMultiSelect
        className={cn(
          'bg-shared-white min-h-8 h-8 rounded-lg text-sm font-normal [&>div>span]:font-normal [&>div>span]:text-sm hover:bg-shared-white',
        )}
        canClear={false}
        canClose={false}
        placeholder={hostLabel}
        selectAllLabel={selectAllLabel}
        selectedOptions={selectedOptions}
        options={options}
        onChange={handleChange}
        onSearch={handleSearch}
        searchValue={searchValue}
        searchPlaceholder={formatMessage({ id: 'labels.searchHosts', defaultMessage: 'Search hosts...' })}
        loading={isLoading}
        onFetchMore={onFetchMore}
        isFetchingMore={isFetchingMore}
        hasMore={hasMore}
        maxCount={selectedOptions.length > 1 ? 0 : 1}
        showSelectAll={false}
        hideMoreDeselect
        moreLabel={
          selectedCount > 0 ? (
            <span className="inline-flex items-center gap-1">
              {hostLabel}
              <Badge className="px-1 py-0 text-[11px] leading-none">{selectedCount}</Badge>
            </span>
          ) : undefined
        }
      />
    </FiltersToolbarFilter>
  );
};
